import React, { useContext, useEffect, useState } from 'react';
import { FormContext } from '../Form';
import Input from '../Input';
import Row from '../../layout/Row';
import { dec2Hex, hex2Dec } from '../../utility/functions';

const ColorInput = ({ ...props }) => {
    const context = useContext(FormContext);
    const [state, setState] = useState(dec2Hex(context.values[props.name || 'logoColor'] || 0));

    useEffect(() => {
        if (context.values[props.name || 'logoColor'])
            setState(dec2Hex(context.values[props.name || 'logoColor']))
    }, [context.initial])

    return (
        <Row>
            <Input
                label='Color'
                value={state}
                name='hexColor'
                type='color'
                style={{ width: '5em', height: '2em' }}
                onInput={e => {
                    const color = e.target.value.replace('#', '');
                    context.values[props.name || 'logoColor'] = hex2Dec(color);
                    setState(e.target.value);
                }}
                flex='0'
                standalone
            />
            <Input
                name={props.name || 'logoColor'}
                type='hidden'
                flex='0'
                {...props}
            />
        </Row>
    )
}

export default ColorInput;
